<template>
  <div class="menu-bar">
    <ul>
      <li class="sub-menu" v-for="(item, index) in list" :key="item.id">
        <span :class="current === index ? 'active' : ''" @click="menuClick(index,item)">{{item.CateName}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default{
  name: 'menuBar',
  data () {
    return {
      current: 0 // 当前索引
    }
  },
  methods: {
    menuClick (index,item) {
      this.current = index; // 设置点击后的激活状态
      this.$emit('menuClick',index, item);
    }
  },
  props: ['list']
}
</script>
<style  scoped>
li{list-style:none;}
.menu-bar {
  height: 50px;
  width: 100%;
  background: rgb(0, 106, 184);
  box-shadow: 0 2px 5px #ccc;
}
.menu-bar ul{
  margin-left: -40px;
}
.sub-menu {
  float: left;
  padding:0 6px;
}
.sub-menu>span{
    color: #fff;
    display:block;
    height:50px;
    line-height:50px;
    text-align:center;
    border-bottom:2px solid #fff;
  }
.sub-menu>span.active,
.sub-menu>span:hover{
  background-color: rgb(4,82,139);
  }

</style>